import { NgModule } from '@angular/core';
import { PreloadAllModules, Router, RouterModule, Routes } from '@angular/router';

import { CustomErrorPageComponent } from './core/components/custom-error-page/custom-error-page.component';
import { environment } from '@env/environment';
import { OktaAuthModule } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { CallbackComponent } from './auth/login/callback.component';
import { AuthGuard } from './auth/auth.guard';

export function onAuthRequired(oktaAuth: OktaAuth, injector: any ): void {
    // Use injector to access any service available within your application
    const router = injector.get(Router);

    // Redirect the user to your custom login page
    router.navigate(['/login']);
}

const routes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    {
        path: 'implicit/callback',
        component: CallbackComponent
    },
    { path: 'registro', loadComponent: () => import('./auth/register/register.component').then(m => m.RegisterComponent) },
    {
        path: 'registro/identidad-validada',
        loadComponent: () => import('./auth/identity-validated/identity-validated.component').then(m => m.IdentityValidatedComponent)
    },
    {
        path: 'recuperar-contrasena',
        loadComponent: () => import('./auth/recover-password/recover-password.component').then(m => m.RecoverPasswordComponent)
    },
    { path: 'confirmar-otp', loadComponent: () => import('./auth/confirm-otp/confirm-otp.component').then(m => m.ConfirmOtpComponent) },
    {
        path: 'restablecer-contrasena',
        loadComponent: () => import('./auth/restore-password/restore-password.component').then(m => m.RestorePasswordComponent)
    },
    { path: 'logout-success', loadComponent: () => import('./auth/logout-success/logout-success.component').then(m => m.LogoutSuccessComponent) },
    {
        path: 'session-expired',
        loadComponent: () => import('./auth/session-expired/session-expired.component').then(m => m.SessionExpiredComponent)
    },
    {
        path: '',
        loadChildren: () => import('./main/main.module').then(m => m.MainModule),

        data: { key: 'main', onAuthRequired },
        canActivate: [AuthGuard],
    },
    {
        path: 'login',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule), data: { key: 'login' }
    },
    { path: '**', component: CustomErrorPageComponent, data: { key: 'error' } }
];
const oktaAuth = new OktaAuth(environment.okta_config);
@NgModule({
    imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }), OktaAuthModule.forRoot({oktaAuth})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
